import { ConfirmDialog, LogoutIcon } from "@picklebet/ui";
import React from "react";
import { useShellStore } from "@/features/shell/stores/shellStore";
import { useLocation } from "@/hooks/useLocation";

export const OpenInAppDialog = () => {
  const modal = useShellStore((state) => state.modal);
  const setModal = useShellStore((state) => state.setModal);
  const { href } = useLocation();

  return (
    <ConfirmDialog
      icon={<LogoutIcon />}
      title={`Open in App`}
      description={`Would you like to view this content in the app?`}
      onClose={() => setModal(null)}
      isOpen={modal === "openApp"}
      onConfirm={async () => window.open(href, "_blank")}
    />
  );
};
